import type { SVGProps } from "react";
const SvgIconSmartphoneClassic = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M628 128H396c-55.23 0-100 44.77-100 100v568c0 55.23 44.77 100 100 100h232c55.23 0 100-44.77 100-100V228c0-55.23-44.77-100-100-100m-232 50h31.07c6.07 0 11.46 3.64 13.71 9.28A25.01 25.01 0 0 0 463.99 203h96c10.22 0 19.42-6.22 23.21-15.71 2.26-5.64 7.64-9.29 13.71-9.29h31.07c27.57 0 50 22.43 50 50v568c0 27.57-22.43 50-50 50h-232c-27.57 0-50-22.43-50-50V228c0-27.57 22.43-50 50-50Z" />
    <circle cx={512} cy={781} r={40} />
  </svg>
);
export default SvgIconSmartphoneClassic;
